import { useQuery } from '@tanstack/react-query';
import { cartServices } from './cart.service';

const useGetCart = () => {
  return useQuery({
    queryKey: ['carts'],
    queryFn: cartServices.getAllCarts,
    refetchOnWindowFocus: false,
  });
};

const useGetCartById = (id: string) => {
  return useQuery({
    queryKey: ['cart', id],
    queryFn: () => cartServices.getCartById(id),
    enabled: !!id,
    refetchOnWindowFocus: false,
  });
};

export { useGetCart, useGetCartById };
